import { getpois } from '@/api/pois'

const state = () => {
  return {
    Pois: [],
    MapPois: []
  }
}

const getters = {
  Pois: (state) => state.Pois,
  MapPois: (state) => state.MapPois
}

const mutations = {
  // new
  SET_Pois: (state, pois) => {
    state.Pois = pois
  },
  SET_MapPois: (state, pois) => {
    state.MapPois = pois
  }
}

const actions = {
  GetPois({ commit }, filter) {
    return new Promise((resolve, reject) => {
      getpois(filter).then(response => {
        commit('SET_Pois', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  SetMapPois({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_MapPois', data)
      resolve(data)
    })
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
